import React from 'react';
import { Divider, Flex, Typography } from '@banhala/ui-kit';
import { useGoodsLegalNotice } from '../../ProductInfo/queries/useGoodsLegalNotice';

export const MDComment: React.FC = () => {
  const { data } = useGoodsLegalNotice();

  if (data == null || data.md_comment == null || data.md_comment === '') {
    return null;
  }

  return (
    <>
      <Divider size="medium" />
      <Flex padding={{ horizontal: 16, vertical: 16 }} gap={8}>
        <Typography type="h5" color="content_secondary">
          MD COMMENT
        </Typography>
        <Typography type="body4" color="content_secondary">
          {data.md_comment}
        </Typography>
      </Flex>
    </>
  );
};
